import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { otherCITabs } from "./welcome_other_ci.js";

const ghaOIDCInstructions = (project: WireTypes.Project) => markdown`
  Enable the \`id-token: write\` permission in your workflow. GitHub Actions ships with \`npx\`, so \`@flakiness/junit-xml\` runs without a separate install step:

  ${markdown.yaml(`
    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      # ... your existing test steps producing JUnit XML in ./test-results ...
      - name: Convert and upload to Flakiness.io
        if: always()
        run: npx @flakiness/junit-xml ./test-results --flakiness-project ${project.org.orgSlug}/${project.projectSlug}
  `, `.github/workflows/tests.yml`, { ins: [[1, 3], [8, 10]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience. The upload runs in \`after_script\`, which executes even when tests fail:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      script:
        - ./run-tests.sh # your existing test command, producing JUnit XML in ./test-results
      after_script:
        - npx @flakiness/junit-xml ./test-results --flakiness-project ${project.org.orgSlug}/${project.projectSlug}
  `, `.gitlab-ci.yml`, { ins: [[2, 4], [7, 8]] })}
`;

export const welcome_junit = (project: WireTypes.Project) => {
  const otherCi = otherCITabs({
    idPrefix: 'junit',
    project,
    testCommand: '<your test command producing JUnit XML in ./test-results>',
    junitPath: './test-results',
  });
  return markdown`

For runners without a native reporter, produce JUnit XML, then use [\`@flakiness/junit-xml\`](https://github.com/flakiness/junit-xml) to convert and upload it. Pick your provider below.

${ciTabs({
  idPrefix: 'junit',
  project,
  githubActions: ghaOIDCInstructions(project),
  gitlabCI: gitlabOIDCInstructions(project),
  otherCI: otherCi,
})}
`;
};
